<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-text>
          <v-alert v-if="!sitebuilders.length" type="info" class="ma-0">
            There are currently no active site builders activated for your hosting service.
          </v-alert>
          <v-data-table
            v-else
            :headers="headers"
            :items="sitebuilders"
          >
            <template v-slot:item.renewaldate="{ item }">
              {{ formatRenewalDate(parseRenewalDate(item.renewaldate)) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <gg-btn
                text
                color="primary"
                :disabled="item.status !== 'Active'"
                @click="login(item.id)"
              >
                Login
              </gg-btn>
            </template>
          </v-data-table>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { statusColor, parseRenewalDate, formatRenewalDate } from '@/helpers/helpers'
import amapi from '@/api/amapi'

export default {
  name: 'HostingSiteBuilder',
  data () {
    return {
      headers: [
        {
          text: 'Site Builder',
          value: 'name',
        },
        {
          text: 'Price',
          value: 'renewalcost',
        },
        {
          text: 'Billing Cycle',
          value: 'renewalterm',
        },
        {
          text: 'Due Date',
          value: 'renewaldate',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        }
      ],
      attemptingLogin: false,
    }
  },
  computed: {
    ...mapGetters(['hosting', 'services', 'servicegroups']),
    sitebuilders () {
      return this.services.filter(x => x.related_service === this.hosting.id).filter(x => x.type == 'builder')
    },
  },
  methods: {
    ...mapActions(['reportError']),
    statusColor,
    parseRenewalDate,
    formatRenewalDate,
    login (id) {
      let w = window.open()
      w.document.write('Connecting...')
      this.attemptingLogin = true
      amapi.makecall('sitebuilder_login', { id }).then(x => {
        this.attemptingLogin = false
        if (x.result === 'success') {
          w.location = x.url
        } else {
          w.close()
          this.reportError('Unable to login to site builder')
        }
      }, x => {
        this.attemptingLogin = false
        this.reportError('Unable to login to site builder')
      })
    },
  }
}
</script>
